import styled from "styled-components";

export const Container = styled.div`
  padding-top: 20px;
`;
export const ImgLink = styled.a`
  margin-bottom: 10px;
`;
